module.exports = __webpack_public_path__ + "img/delivery-fill.a6bc586e.svg";